// extracted by mini-css-extract-plugin
module.exports = {"Page":"Glossary_Page__GZZSD","Section":"Glossary_Section__pSnWI","Definition":"Glossary_Definition__jYnjt"};